import { ChangeEvent, useEffect, useState } from "react";
import useFormStore from "../../store/formData";
import TextInput from "../TextInput/TextInput";

const TextInputContainer = (props) => {
  const { formData, setFormData } = useFormStore();
  const [value, setValue] = useState("");

  useEffect(() => {
    formData[props.data.id]
      ? setValue(formData[props.data.id])
      : setFormData(props.data.id, "");
  }, []);

  function selectChangeHandler(value) {
    setValue(value);
    setFormData(props.data.id, value);
  }

  return (
    <TextInput
      size="md" // lg , md , sm , null
      label={props.data.name} // string , null
      value={value} // state
      icon={props.data.icon} // string , null
      disabled={false} // boolian , null
      type={props.data.type === "number" ? "number" : "text"} // text , number , null
      // validation={phoneValidation} // string , null
      placeholder={""} // string , null
      onChange={(e) => {
        selectChangeHandler(e.target.value);
      }} // setState()
      id={props.data.id}
    />
  );
};

export default TextInputContainer;
